import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import { FaSpinner } from 'react-icons/fa';

import './DownloadButton.scss';

class DownloadButton extends React.Component {
  render() {
    return (
      <Button
        size="lg"
        block
        variant="outline-secondary"
        className="atlas-legend__download-button"
        onClick={this.props.handler}
        disabled={this.props.loading}
      >
        {this.props.loading ? <FaSpinner className="fa-spin" /> : this.props.icon}
        {this.props.text}
      </Button>
    );
  }
}

DownloadButton.propTypes = {
  handler: PropTypes.func.isRequired,
  icon: PropTypes.element,
  loading: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

export default DownloadButton;
